'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$PolicyCode$() {
  this.c8p = null;
  this.c8q = false;
  this.c8n = null;
  this.c8o = false;
}
export { $c_Lpresto_types$PolicyCode$ as $c_Lpresto_types$PolicyCode$ };
$p = $c_Lpresto_types$PolicyCode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$PolicyCode$;
/** @constructor */
function $h_Lpresto_types$PolicyCode$() {
}
export { $h_Lpresto_types$PolicyCode$ as $h_Lpresto_types$PolicyCode$ };
$h_Lpresto_types$PolicyCode$.prototype = $p;
$p.ady = (function() {
  if ((!this.c8q)) {
    this.c8p = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c8q = true;
  }
  return this.c8p;
});
$p.SK = (function() {
  if ((!this.c8o)) {
    this.c8n = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c8o = true;
  }
  return this.c8n;
});
var $d_Lpresto_types$PolicyCode$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$PolicyCode$, "presto.types$PolicyCode$", ({
  a0M: 1,
  D: 1
}));
export { $d_Lpresto_types$PolicyCode$ as $d_Lpresto_types$PolicyCode$ };
var $n_Lpresto_types$PolicyCode$;
function $m_Lpresto_types$PolicyCode$() {
  if ((!$n_Lpresto_types$PolicyCode$)) {
    $n_Lpresto_types$PolicyCode$ = new $c_Lpresto_types$PolicyCode$();
  }
  return $n_Lpresto_types$PolicyCode$;
}
export { $m_Lpresto_types$PolicyCode$ as $m_Lpresto_types$PolicyCode$ };
//# sourceMappingURL=presto.types$-Policy-Code$.js.map
